export enum Routes {
  DashboardRouter = "/",
}
